<template>
  <div :id="notification.docId" class="notification-container" :class="{ show: show }">
    <div class="notification-time">
      <div class="newest-notification" v-if="newestNotification"></div>
      <timesince
        :timestamp="`${notification.timestamp}Z`"
      />
    </div>

    <SidebarNotification
    v-if="notificationMeta && notificationMeta.sidebarNotificationComponent"
    :data="notification"
    />
  </div>
</template>

<script>
import Timesince from '@/components/sidebar/Timesince.vue';

import SidebarNotification from "@/components/notifications/sidebar/SidebarNotification.vue"

import { mapGetters } from "vuex"

export default {
  name: 'SidebarNotificationContainer',
  props: {
    notification: Object,
    currentNotificationType: String,
    index: Number
  },
  components: {
    SidebarNotification,
    Timesince
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ... mapGetters(['getNotificationMeta']),
    notificationMeta() {
      return this.getNotificationMeta(this.notification)
    },
    currentNotification() {
      return this.$store.getters.getCurrentNotification;
    },
    newestNotification() {
      let newestNotification = false;
      if (this.notification === this.currentNotification) {
        newestNotification = true;
      }
      return newestNotification;
    },
    meetingEnded() {
      return this.notification?.missed
    }
  },
  mounted() {
    let loadTime = 150 + 30 * this.index;
    setTimeout(() => {
      this.show = true;
    }, loadTime);
  }
};
</script>

<style scoped lang="scss">
@import '~@/scss/components/sidebar/sidebar_notification_container.scss';
</style>
